import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {isIE} from '@util/browser';
import {AuthService} from '@common/messe-ui-toolkit';
import {Router, RouterLink} from '@angular/router';
import {take} from 'rxjs/operators';
import {RouteBuilder} from '@util/route-builder';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLink],
})
export class LandingComponent implements OnInit {
  isIE = isIE;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    this.authService
      .isLoggedIn()
      .pipe(take(1))
      .subscribe((loggedIn) => {
        if (loggedIn) {
          // noinspection JSIgnoredPromiseFromCall
          this.router.navigate([RouteBuilder.login().build()]);
        }
      });
  }

  get loginRoute(): string {
    return RouteBuilder.login().build();
  }
}
